import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxNoDataComponent } from './rx-no-data.component';

@NgModule({
  imports: [CommonModule, RxNoDataComponent],
  exports: [RxNoDataComponent],
})
export class RxNoDataModule {}
